export interface UserActionTypes {
    type: UserActions;
    payload?: any;
}


export enum UserActions {
  LOGIN_REQUEST = "LOGIN_REQUEST",
  LOGOUT_USER = "LOGOUT_USER",
  SET_USER = "SET_USER",
  RESET_ALL_DATA = "RESET_ALL_DATA",
  CREATE_USER = "CREATE_USER",
  GET_USER_LIST = "GET_USER_LIST",
  SET_USER_LIST = "SET_USER_LIST",
  SET_USER_LIST_PAGE_COUNT = "SET_USER_LIST_PAGE_COUNT",
  GET_USER_DATA_BY_ID = "GET_USER_DATA_BY_ID",
  SET_USER_DATA_BY_ID = "SET_USER_DATA_BY_ID",
  EDIT_USER_DETAILS = "EDIT_USER_DETAILS",
  GET_LOGGEDIN_USER_DATA = "GET_LOGGEDIN_USER_DATA",
  SET_LOGGEDIN_USER_DATA = "SET_LOGGEDIN_USER_DATA",
  CHANGE_USER_PASSWORD = "CHANGE_USER_PASSWORD",
}